export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="flex flex-col items-center gap-6 text-center">
          <a href="#top" className="flex items-center gap-2 cursor-pointer">
            <img
              src="https://up.abstractdata.ai/uploads/2025/08/AbstractDataLogo-2.png"
              alt="Abstract Data"
              className="h-6 w-auto"
            />
            <span className="font-heading font-semibold text-sm text-foreground-950">
              Abstract Data
            </span>
          </a>

          <p className="text-sm text-foreground-500">
            © {new Date().getFullYear()} Abstract Data — All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}